<template>
    <ConfirmDialog
            ref="confirmDialog"
            :accept-title="$t('leave')"
            :messages="[$t('warnings.unsavedChanges')]"
            :popup-title="$t('warnings.confirmLeavePage')"
            :title="$t('warnings.areYouSureLeave')"/>
</template>

<script>
import ConfirmDialog from "@/components/reusable/Dialog/ConfirmDialog";

export default {
  name: "LeaveConfirmDialog",
  components: {ConfirmDialog},
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    deleteTitle: {
      type: String,
      required: false,
      default: ''
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data() {
    return {
      open: false,
      resolve: null,
      reject: null
    };
  },
  methods: {
    openDialog() {
      this.open = true;
      return this.$refs.confirmDialog.openDialog();
    },
  }
};
</script>

<style scoped>

</style>